import { openApiPcp } from '@/api/PCP/request'

export default {
  // 赠品详情
  getProductBriefInfo (requestData) {
    return openApiPcp.post('/api/product/getProductBriefInfo', requestData)
  },
  getShorexCommonInfo(data) {
    return openApiPcp.post('/api/Product/ShorexCommonInfo', data);
  }
}
